import { useBamboraContext } from './useBamboraContext';

const BamboraPayment = (): JSX.Element => {
    const { iframeURL } = useBamboraContext();

    if (!iframeURL) {
        return (
            <div>Error initialize Bambora payment</div>
        );
    }

    return (
        <div>
            <div className="bambora-iframe-wrapper">
                {/* eslint-disable-next-line react/iframe-missing-sandbox */}
                <iframe
                    src={iframeURL}
                    style={{
                        width: '100%',
                        minWidth: '100%',
                        backgroundColor: 'transparent',
                        border: 'none',
                    }}
                />
            </div>
        </div>
    );
};

export default BamboraPayment;
